var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayout1280(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 314.24 119.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #006300;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 157.37,
    y1: -10.76,
    x2: 156.87,
    y2: 138.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0774eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0673e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0670e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#066ad6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0562c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0458af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#034c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#023d74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#01325b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0.2,
    y: 0.15,
    width: 313.83,
    height: 113.34,
    rx: 4.18,
    ry: 4.18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 157.37,
    y1: -17.14,
    x2: 156.94,
    y2: 111.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54c4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4fbfea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#43b2ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2e9cea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#107eea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006deb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0,
    y: 6.38,
    width: 314.24,
    height: 113.49,
    rx: 4.21,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -144.07,
    y: -15.7,
    width: 602.38,
    height: 145.03
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m310.02,113.49H4.21c-2.33,0-4.21-1.89-4.21-4.21V4.21C0,1.89,1.89,0,4.21,0h305.81c2.33,0,4.21,1.89,4.21,4.21v105.06c0,2.33-1.89,4.21-4.21,4.21Zm-12.66-11.1V11.1c0-2.76-2.24-5-5-5H21.88c-2.76,0-5,2.24-5,5v91.3c0,2.76,2.24,5,5,5h270.49c2.76,0,5-2.24,5-5Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.45,55.62c-.65,1.21-1.68,2.18-3.07,2.92-1.39.74-3.15,1.11-5.27,1.11h-4.33v9.92h-5.18v-25.83h9.51c2,0,3.7.35,5.11,1.04,1.41.69,2.46,1.64,3.16,2.85.7,1.21,1.05,2.58,1.05,4.11,0,1.38-.33,2.68-.98,3.88Zm-5.38-1.13c.69-.65,1.04-1.57,1.04-2.76,0-2.52-1.41-3.77-4.22-3.77h-4.11v7.51h4.11c1.43,0,2.49-.33,3.18-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m66.19,64.65h-10.29l-1.7,4.92h-5.44l9.29-25.86h6.03l9.29,25.86h-5.48l-1.7-4.92Zm-1.41-4.14l-3.74-10.8-3.74,10.8h7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m96.64,43.75l-8.73,16.83v8.99h-5.18v-8.99l-8.77-16.83h5.85l5.55,11.8,5.51-11.8h5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m104.23,68.13c-2.02-1.13-3.63-2.71-4.81-4.72-1.18-2.01-1.78-4.29-1.78-6.83s.59-4.78,1.78-6.79c1.18-2.01,2.79-3.58,4.81-4.72,2.02-1.13,4.24-1.7,6.66-1.7s4.67.57,6.68,1.7c2.01,1.13,3.6,2.71,4.77,4.72,1.17,2.01,1.76,4.27,1.76,6.79s-.59,4.82-1.76,6.83c-1.17,2.01-2.77,3.58-4.79,4.72-2.02,1.13-4.24,1.7-6.66,1.7s-4.64-.57-6.66-1.7Zm10.77-3.98c1.18-.7,2.11-1.71,2.77-3.01s1-2.82,1-4.55-.33-3.24-1-4.53-1.59-2.29-2.77-2.98-2.55-1.04-4.11-1.04-2.93.35-4.13,1.04c-1.2.69-2.13,1.68-2.79,2.98s-1,2.81-1,4.53.33,3.24,1,4.55,1.6,2.31,2.79,3.01c1.2.7,2.57,1.05,4.13,1.05s2.92-.35,4.11-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m132.31,43.75v15.98c0,1.75.46,3.09,1.37,4.01.91.92,2.2,1.39,3.85,1.39s2.97-.46,3.89-1.39c.91-.93,1.37-2.26,1.37-4.01v-15.98h5.22v15.95c0,2.2-.48,4.05-1.42,5.57-.95,1.52-2.22,2.66-3.81,3.42-1.59.76-3.36,1.15-5.31,1.15s-3.67-.38-5.24-1.15-2.81-1.91-3.72-3.42c-.91-1.52-1.37-3.37-1.37-5.57v-15.95h5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m169.83,43.75v4.18h-6.88v21.64h-5.18v-21.64h-6.88v-4.18h18.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m179.71,47.37v-4.77h8.92v26.97h-5.33v-22.2h-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m193.56,53.64c-.6-.58-.91-1.3-.91-2.16s.3-1.58.91-2.17c.6-.58,1.37-.87,2.31-.87s1.67.29,2.26.87c.59.58.89,1.3.89,2.17s-.3,1.58-.89,2.16c-.59.58-1.34.87-2.26.87s-1.71-.29-2.31-.87Zm0,15.32c-.6-.58-.91-1.3-.91-2.17s.3-1.58.91-2.16c.6-.58,1.37-.87,2.31-.87s1.67.29,2.26.87c.59.58.89,1.3.89,2.16s-.3,1.59-.89,2.17c-.59.58-1.34.87-2.26.87s-1.71-.29-2.31-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m209.42,47.37v-4.77h8.92v26.97h-5.33v-22.2h-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m224.33,63.73c2.37-1.97,4.26-3.62,5.66-4.94s2.58-2.7,3.52-4.13c.94-1.43,1.41-2.84,1.41-4.22,0-1.26-.3-2.24-.89-2.96-.59-.71-1.5-1.07-2.74-1.07s-2.18.41-2.85,1.24c-.67.83-1.01,1.96-1.04,3.39h-5.03c.1-2.96.98-5.2,2.65-6.73,1.67-1.53,3.78-2.29,6.35-2.29,2.81,0,4.97.75,6.48,2.24,1.5,1.49,2.26,3.46,2.26,5.9,0,1.92-.52,3.76-1.55,5.51-1.04,1.75-2.22,3.27-3.55,4.57s-3.07,2.86-5.22,4.68h10.92v4.29h-18.28v-3.85l1.92-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m244.01,49.33c0-1.33.34-2.55,1.02-3.64.68-1.1,1.7-1.97,3.07-2.63,1.37-.65,3.04-.98,5.01-.98s3.64.33,5.01.98c1.37.65,2.39,1.53,3.07,2.63.68,1.1,1.02,2.31,1.02,3.64s-.33,2.55-1,3.57c-.67,1.02-1.55,1.82-2.66,2.39,1.36.59,2.42,1.46,3.18,2.59.76,1.13,1.15,2.48,1.15,4.03,0,1.68-.43,3.14-1.28,4.38-.85,1.25-2.02,2.2-3.5,2.87s-3.15,1-5,1-3.51-.33-4.98-1c-1.47-.67-2.63-1.62-3.48-2.87-.85-1.25-1.28-2.71-1.28-4.38,0-1.55.38-2.9,1.15-4.05.76-1.15,1.83-2,3.18-2.57-2.47-1.28-3.7-3.27-3.7-5.96Zm5.68,9.29c-.88.72-1.31,1.74-1.31,3.07,0,1.23.43,2.24,1.28,3.02.85.78,2,1.17,3.46,1.17s2.6-.39,3.44-1.18c.84-.79,1.26-1.79,1.26-3,0-1.31-.43-2.33-1.3-3.05s-2-1.09-3.4-1.09-2.55.36-3.42,1.07Zm6.4-11.36c-.73-.67-1.72-1-2.98-1s-2.21.33-2.94,1c-.73.67-1.09,1.62-1.09,2.85,0,1.11.38,2,1.13,2.66.75.67,1.72,1,2.9,1s2.16-.34,2.92-1.02,1.15-1.57,1.15-2.68c0-1.21-.36-2.15-1.09-2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m268.56,45.71c1.54-2.42,4.1-3.63,7.68-3.63s6.14,1.21,7.68,3.63c1.54,2.42,2.31,5.76,2.31,10.03s-.77,7.66-2.31,10.1c-1.54,2.44-4.1,3.66-7.68,3.66s-6.14-1.22-7.68-3.66c-1.54-2.44-2.31-5.81-2.31-10.1s.77-7.61,2.31-10.03Zm12.21,5.42c-.23-1.25-.7-2.26-1.41-3.05-.7-.79-1.75-1.18-3.13-1.18s-2.42.39-3.13,1.18c-.7.79-1.17,1.81-1.41,3.05-.23,1.25-.35,2.78-.35,4.61s.11,3.45.33,4.72c.22,1.27.69,2.29,1.41,3.07.71.78,1.76,1.17,3.15,1.17s2.43-.39,3.15-1.17c.71-.78,1.18-1.8,1.41-3.07s.33-2.84.33-4.72-.12-3.36-.35-4.61Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayout1280);
export default __webpack_public_path__ + "static/media/payout-1280.405fead3836a6839350f066dc5bca921.svg";
export { ForwardRef as ReactComponent };